/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DistributeOnboardingCandidateRequestBody,
  DistributeOnboardingCandidateRequestBody$Outbound,
  DistributeOnboardingCandidateRequestBody$outboundSchema,
} from "../components/distributeonboardingcandidaterequestbody.js";

export type RemovePlatformMCPOnboardingDistributionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RemovePlatformMCPOnboardingDistributionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  distributeOnboardingCandidateRequestBody:
    DistributeOnboardingCandidateRequestBody;
};

/** @internal */
export type RemovePlatformMCPOnboardingDistributionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RemovePlatformMCPOnboardingDistributionSecurity$outboundSchema:
  z.ZodMiniType<
    RemovePlatformMCPOnboardingDistributionSecurity$Outbound,
    RemovePlatformMCPOnboardingDistributionSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function removePlatformMCPOnboardingDistributionSecurityToJSON(
  removePlatformMCPOnboardingDistributionSecurity:
    RemovePlatformMCPOnboardingDistributionSecurity,
): string {
  return JSON.stringify(
    RemovePlatformMCPOnboardingDistributionSecurity$outboundSchema.parse(
      removePlatformMCPOnboardingDistributionSecurity,
    ),
  );
}

/** @internal */
export type RemovePlatformMCPOnboardingDistributionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  DistributeOnboardingCandidateRequestBody:
    DistributeOnboardingCandidateRequestBody$Outbound;
};

/** @internal */
export const RemovePlatformMCPOnboardingDistributionRequest$outboundSchema:
  z.ZodMiniType<
    RemovePlatformMCPOnboardingDistributionRequest$Outbound,
    RemovePlatformMCPOnboardingDistributionRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      distributeOnboardingCandidateRequestBody:
        DistributeOnboardingCandidateRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        distributeOnboardingCandidateRequestBody:
          "DistributeOnboardingCandidateRequestBody",
      });
    }),
  );

export function removePlatformMCPOnboardingDistributionRequestToJSON(
  removePlatformMCPOnboardingDistributionRequest:
    RemovePlatformMCPOnboardingDistributionRequest,
): string {
  return JSON.stringify(
    RemovePlatformMCPOnboardingDistributionRequest$outboundSchema.parse(
      removePlatformMCPOnboardingDistributionRequest,
    ),
  );
}
